export default "__VITE_ASSET__ClcoIMVS__"